import type { ReactNode } from 'react';
import { useLiveVideo } from '../hooks/useLiveVideo';
import { useLiveChat } from '../hooks/useLiveChat';
import { LiveSessionContext } from './liveSession';

/**
 * Holds the visit's video room and chat conversation above the screens — see
 * ./liveSession for what that fixes.
 */
export function LiveSessionProvider({ children }: { children: ReactNode }) {
  // The single owners of the video and chat providers. Nothing else in the app may
  // call these two hooks — a second call is a second connection.
  const video = useLiveVideo();
  const chat = useLiveChat();

  return (
    <LiveSessionContext.Provider value={{ video, chat }}>
      {children}
    </LiveSessionContext.Provider>
  );
}
